import { Device } from 'mediasoup-client';
//import socketClient from 'socket.io-client';
import { promise as socketPromise } from './lib/socket.io-promise';
import { colyseusObj } from './colyseus';

export let voiceChatObj;

WL.registerComponent('voice-chat', {
  hostname: { type: WL.Type.String, default: '' },
  listenPort: { type: WL.Type.Int, default: 3000 },
  videoScreen: { type: WL.Type.Object }
}, {
  init: function () {
    let device;
    let socket;
    let producer;
    let hostname = this.hostname;
    let listenPort = this.listenPort;
    let videoScreen = this.videoScreen;

    this.context = new AudioContext();
    this.analyzer = this.context.createAnalyser();
    this.analyzer.connect(this.context.destination);
    this.playerVoiceMap = {};

    const self = this;
    voiceChatObj = this;

    document.addEventListener('keydown', e => {
      if (e.ctrlKey && e.key === '0') {
        listenPort = 2096;
        console.log('Switched to voice staging server');
      }
    });

    if (typeof navigator.mediaDevices.getDisplayMedia === 'undefined') {
      console.log('Media not supported');
    }

    async function connect(colyseusId) {
      console.log('Connecting...');

      const opts = {
        path: '/server',
        transports: ['websocket'],
        query: {
          colyseusId: colyseusId,
          roomId: colyseusObj.room.id
        }
      };

      const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';
      const serverUrl = isLocal ? `http://${hostname}:${listenPort}` : `https://${hostname}:${listenPort}`;
      socket = io(serverUrl, opts);
      this.socket = socket;
      socket.request = socketPromise(socket);

      socket.on('connect', async () => {
        console.log('Connected');

        const data = await socket.request('getRouterRtpCapabilities');
        await loadDevice(data);
        await publish();
      });

      socket.on('disconnect', () => {
        console.log('Disconnected');
      });

      socket.on('connect_error', (error) => {
        console.error('could not connect to %s%s (%s)', serverUrl, opts.path, error.message);
        console.log('Connection failed');
      });

      socket.on('newProducer', async (data) => {
        const { id, colyseusId } = data;
        if (id === socket.id) return;
        await subscribe(id, colyseusId);
      });
    }
    this.connectFunc = connect;

    async function loadDevice(routerRtpCapabilities) {
      try {
        device = new Device();
      } catch (error) {
        if (error.name === 'UnsupportedError') {
          console.error('browser not supported');
        }
      }
      console.log('loading new device');
      await device.load({ routerRtpCapabilities });
    }

    async function publish(colyseusId) {
      const data = await socket.request('createProducerTransport', {
        forceTcp: false,
        rtpCapabilities: device.rtpCapabilities,
        colyseusId
      });
      if (data.error) {
        console.error(data.error);
        return;
      }

      const transport = device.createSendTransport(data);
      transport.on('connect', async ({ dtlsParameters }, callback, errback) => {
        socket.request('connectProducerTransport', { dtlsParameters })
          .then(callback)
          .catch(errback);
      });

      transport.on('produce', async ({ kind, rtpParameters }, callback, errback) => {
        try {
          const { id } = await socket.request('produce', {
            transportId: transport.id,
            kind,
            rtpParameters,
          });
          callback({ id });
        } catch (err) {
          errback(err);
        }
      });

      transport.on('connectionstatechange', (state) => {
        switch (state) {
          case 'connecting':
            console.log('Publishing...');
          break;

          case 'connected':
            console.log('Published');
          break;

          case 'failed':
            transport.close();
            console.log('Failed to publish to voice server.');
          break;

          default: break;
        }
      });

      let stream;
      try {
        stream = await getUserMedia(transport);
        const track = stream.getAudioTracks()[0];
        // Add some checks on the audio track in the case of random cutouts
        track.onended = () => {
          console.log('Audio stream track has ended.');
        }
        setInterval(() => {
          if (!track.enabled) track.enabled = true;
        }, 1000);
        const params = { track };
        producer = await transport.produce(params);
        const recorder = new MediaRecorder(stream);
        recorder.ondataavailable = async e => {
          const blob = e.data;
          const buffer = await blob.arrayBuffer();
          const view = new Int8Array(buffer);
          for (const el in view) {
            if (Number.isNaN(el) || el === 0) {
              console.log('BAD VALUE IN STREAM BUFFER! Attempting to reset connection...');
              producer.close();
              producer = await transport.produce(params);
            }
          }
        }
        recorder.start(3000);
      } catch (err) {
        console.error(err);
        console.log('Failed to create producer transport.');
      }
    }

    async function getUserMedia() {
      if (!device.canProduce('audio')) {
        console.error('Cannot produce audio');
        return;
      }

      let stream;
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      } catch (err) {
        console.error('getUserMedia() failed:', err.message);
        throw err;
      }
      return stream;
    }

    async function subscribe(peerid, colyseusId) {
      const data = await socket.request('createConsumerTransport', {
        forceTcp: false,
        peerid: peerid
      });
      if (data.error) {
        console.error(data.error);
        return;
      }

      // Stopgap solution for device not yet being loaded before subscribing
      if (!device.loaded) await new Promise(resolve => setTimeout(resolve, 1000));

      const transport = device.createRecvTransport(data);
      transport.on('connect', ({ dtlsParameters }, callback, errback) => {
        socket.request('connectConsumerTransport', {
          transportId: transport.id,
          dtlsParameters
        })
          .then(callback)
          .catch(errback);
      });

      transport.on('connectionstatechange', async (state) => {
        switch (state) {
          case 'connecting':
            console.log('Subscribing...');
            break;

          case 'connected':
            if (!stream) return;

            self.playerVoiceMap[peerid] = {
              stream: stream,
              volume: 0,
              name: colyseusObj.players.get(colyseusId).name
            }
            
            // Create MediaStreamAudioSource for volume analysis
            // https://stackoverflow.com/a/64650826/6806582
            const analyzer = self.context.createAnalyser();
            const source = self.context.createMediaStreamSource(stream);
            analyzer.fftSize = 512;
            analyzer.minDecibels = -127;
            analyzer.maxDecibels = 0;
            analyzer.smoothingTimeConstant = 0.4;
            source.connect(analyzer);
            const volumes = new Uint8Array(analyzer.frequencyBinCount);
            const volumeCallback = () => {
              analyzer.getByteFrequencyData(volumes);
              let volumeSum = 0;
              for(const volume of volumes)
                volumeSum += volume;
              const averageVolume = volumeSum / volumes.length;
              self.playerVoiceMap[peerid].volume = averageVolume;
            };
            setInterval(volumeCallback, 250);

            // Create audio element for listening
            const audio = document.createElement('audio');
            document.body.appendChild(audio);
            audio.autoplay = true;
            audio.srcObject = stream;
            await socket.request('resume');
            console.log('Subscribed to new producer.');
            break;

          case 'failed':
            transport.close();
            console.log('Failed to subscribe to new producer.');
            break;

          default: break;
        }
      });

      const stream = await consume(transport, peerid);
      if (stream.getVideoTracks().length > 0 && videoScreen) {
        videoScreen.getComponent('video-stream-texture').video.srcObject = stream;
        videoScreen.getComponent('video-stream-texture').video.play();
      }
    }

    async function consume(transport, peerid) {
      let mediastream = new MediaStream();
      const { rtpCapabilities } = device;
      const data = await socket.request('consume', { rtpCapabilities, peerid, transportId: transport.id });
      for (const producer in data) {
        try {
          const {
            producerId,
            id,
            kind,
            rtpParameters,
          } = data[producer];
    
          let codecOptions = {};
          const consumer = await transport.consume({
            id,
            producerId,
            kind,
            rtpParameters,
            codecOptions,
          });
          mediastream.addTrack(consumer.track);
        } catch(e) {
          // No producer stream to consume from, stream will be null
          console.log(e);
          return null;
        }
      }
      return mediastream;
    }
  },
  connect: function(colyseusId) {
    this.connectFunc(colyseusId);
  },
  disconnect: function() {
    this.socket.disconnect();
  }
});